/* eslint-disable camelcase */
import React, { useState } from "react"
import { Box, Grid, Paper, Typography } from "@mui/material"
import { styled, createTheme, ThemeProvider } from "@mui/material/styles"
import AddIcon from "@mui/icons-material/Add"
import EditIcon from "@mui/icons-material/Edit"
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered"

import Header from "../../layouts/Header"
import BackIcon from "../../components/BackIcon"
import CustomConditionalActionsTableServer from "../../components/CustomConditionalActionsTableServerSide"
import ModalTipoProceso from "./components/ModalTipoProceso"
import ModalEtapa from "./components/ModalEtapa"

// Estilos base estandarizados
const StyledRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginTop: theme.spacing(2),
  flexGrow: 1,
  padding: "0 16px",
  height: "100%",
}))

const theme = createTheme({
  palette: { primary: { main: "#196C87" }, secondary: { main: "#2E7D32" } },
})

const CRM_Configuracion = () => {
  const [procesoSeleccionado, setProcesoSeleccionado] = useState(null)

  // Modals State
  const [openModalProceso, setOpenModalProceso] = useState(false)
  const [procesoEdit, setProcesoEdit] = useState(null)

  const [openModalEtapa, setOpenModalEtapa] = useState(false)
  const [etapaEdit, setEtapaEdit] = useState(null)

  // --- Acciones para Procesos ---
  const handleAddProceso = () => {
    setProcesoEdit(null)
    setOpenModalProceso(true)
  }

  const handleEditProceso = (row) => {
    setProcesoEdit(row)
    setOpenModalProceso(true)
  }

  const handleVerEtapas = (row) => {
    setProcesoSeleccionado(row)
  }

  // --- Acciones para Etapas ---
  const handleAddEtapa = () => {
    setEtapaEdit(null)
    setOpenModalEtapa(true)
  }

  const handleEditEtapa = (row) => {
    setEtapaEdit(row)
    setOpenModalEtapa(true)
  }

  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4" style={{ backgroundColor: "#f0f2f5", minHeight: "100vh" }}>
        <BackIcon />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 30px 20px 30px",
            fontSize: "25px",
          }}
        >
          <b>Configurador de Plantillas CRM</b>
        </div>

        <Box className={StyledRoot}>
          <Grid container spacing={2}>
            {/* Panel Izquierdo: Procesos */}
            <Grid item xs={12} md={6}>
              <Paper elevation={3} sx={{ p: 2, borderRadius: 2 }}>
                <Typography variant="h6" color="primary" sx={{ mb: 1, ml: 1 }}>
                  Tipos de Proceso
                </Typography>

                <CustomConditionalActionsTableServer
                  endpoint="/CRM_Carpetas/getConfigTiposProceso"
                  errorMsgFilterSearch="Error al cargar procesos"
                  queryKeyModal="getConfigTiposProceso"
                  perPage={5}
                  rowActionsWidthTable={120}
                  topToolbarCustomActions={() => [
                    {
                      label: "Nuevo Proceso",
                      key: "CREAR_PROCESO",
                      icon: <AddIcon />,
                      onClick: handleAddProceso,
                    },
                  ]}
                  rowActions={(row) => [
                    {
                      label: "Editar",
                      key: "EDITAR",
                      icon: <EditIcon color="primary" />,
                      onClick: (row) => handleEditProceso(row.original),
                    },
                    {
                      label: "Ver Etapas",
                      key: "VER_ETAPAS",
                      icon: <FormatListNumberedIcon color="secondary" />,
                      onClick: (row) => handleVerEtapas(row.original),
                    },
                  ]}
                  columnsTable={[
                    {
                      accessorKey: "pro_id",
                      header: "ID",
                      size: 60,
                      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                    },
                    {
                      accessorKey: "pro_nombre",
                      header: "Proceso",
                      size: 150,
                      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                    },
                    {
                      accessorKey: "pro_origen_erp",
                      header: "Origen ERP",
                      size: 100,
                      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                    },
                    {
                      accessorKey: "pro_estado",
                      header: "Estado",
                      size: 90,
                      Cell: ({ cell }) => <span>{cell.getValue() === "A" ? "ACTIVO" : "INACTIVO"}</span>,
                    },
                  ]}
                />
              </Paper>
            </Grid>

            {/* Panel Derecho: Etapas del Proceso Seleccionado */}
            <Grid item xs={12} md={6}>
              <Paper elevation={3} sx={{ p: 2, borderRadius: 2, minHeight: 400 }}>
                {!procesoSeleccionado ? (
                  <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                    <Typography color="textSecondary">
                      Seleccione un proceso en la tabla izquierda para ver sus etapas.
                    </Typography>
                  </Box>
                ) : (
                  <>
                    <Typography variant="h6" color="primary" sx={{ mb: 1, ml: 1 }}>
                      Etapas: {procesoSeleccionado.pro_nombre}
                    </Typography>

                    <CustomConditionalActionsTableServer
                      // SOLUCIÓN: Pasamos el pro_id como Query Parameter en la URL
                      endpoint={`/CRM_Carpetas/getConfigEtapas?pro_id=${procesoSeleccionado.pro_id}`}
                      errorMsgFilterSearch="Error al cargar etapas"
                      queryKeyModal={`getConfigEtapas_${procesoSeleccionado.pro_id}`}
                      perPage={5}
                      rowActionsWidthTable={100}
                      topToolbarCustomActions={() => [
                        {
                          label: "Nueva Etapa",
                          key: "CREAR_ETAPA",
                          icon: <AddIcon />,
                          onClick: handleAddEtapa,
                        },
                      ]}
                      rowActions={(row) => [
                        {
                          label: "Editar",
                          key: "EDITAR",
                          icon: <EditIcon color="primary" />,
                          onClick: (row) => handleEditEtapa(row.original),
                        },
                      ]}
                      columnsTable={[
                        {
                          accessorKey: "eta_secuencia",
                          header: "Secuencia",
                          size: 90,
                          Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                        },
                        {
                          accessorKey: "eta_nombre",
                          header: "Etapa",
                          size: 160,
                          Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                        },
                        {
                          accessorKey: "eta_tipo",
                          header: "Tipo",
                          size: 120,
                          Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                        },
                        {
                          accessorKey: "eta_sla_horas",
                          header: "SLA (H)",
                          size: 80,
                          Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                        },
                      ]}
                    />
                  </>
                )}
              </Paper>
            </Grid>
          </Grid>
        </Box>
      </div>

      {openModalProceso && (
        <ModalTipoProceso open={openModalProceso} onClose={() => setOpenModalProceso(false)} data={procesoEdit} />
      )}
      {openModalEtapa && (
        <ModalEtapa
          open={openModalEtapa}
          onClose={() => setOpenModalEtapa(false)}
          data={etapaEdit}
          pro_id={procesoSeleccionado?.pro_id}
        />
      )}
    </ThemeProvider>
  )
}

export default CRM_Configuracion
